// extracted by mini-css-extract-plugin
module.exports = {"FontAwesomeIcon":"UpdateEmail_FontAwesomeIcon__3vioz","heading":"UpdateEmail_heading__JnKfM","container":"UpdateEmail_container__PHn16","subCon":"UpdateEmail_subCon__20VjX"};